import styled from "styled-components";

export const Wrapper = styled.div`
  position: relative;
  display: flex;
  flex-wrap: wrap;
`;
